import { Button, H3, useDialog } from '@wheely/ui-kit';
import { FormattedMessage } from 'react-intl';

import s from './styles.module.css';

type UseDataProtectionModalReturnShape = {
  open: () => Promise<boolean>;
};

export const useDataProtectionModal = (): UseDataProtectionModalReturnShape => {
  const { openDialog } = useDialog();

  const open = () =>
    new Promise<boolean>(resolve => {
      openDialog(
        ({ onClose }) => (
          <div>
            <div className={s.body}>
              <FormattedMessage
                id="use_data_protection_modal_body_1"
                defaultMessage='I am the person identified above. I understand that Wheely Technologies Ltd and/or its affiliates (the "Companies") will ask DVLA for my driver record information, as and when they require, in order to verify the status of my driving licence.'
                description="UK data protection declaration body text"
                tagName="p"
              />
              <FormattedMessage
                id="use_data_protection_modal_body_2"
                defaultMessage="I understand DVLA will disclose to the Companies all relevant information held in the computerised register of drivers maintained by DVLA. This includes personal details, driving entitlements (with any associated restriction codes), valid endorsements and disqualifications (if relevant), photo images (in some circumstances), Certificate of Professional Competence (CPC) and digital tachograph card details (where appropriate)."
                description="UK data protection declaration body text"
                tagName="p"
              />
              <FormattedMessage
                id="use_data_protection_modal_body_3"
                defaultMessage="This declaration will expire when I stop driving in connection with the company or in any case, three years from the date of my signature."
                description="UK data protection declaration body text"
                tagName="p"
              />
            </div>
            <Button
              className={s.agreeButton}
              onClick={() => {
                resolve(true);
                onClose();
              }}
            >
              <FormattedMessage
                id="use_data_protection_modal_agree"
                defaultMessage="I AGREE"
                description="UK data protection declaration agree button"
              />
            </Button>
          </div>
        ),
        {
          title: (
            <FormattedMessage
              id="use_data_protection_modal_title"
              defaultMessage="Data Protection Declaration"
              description="UK data protection declaration dialog title"
              tagName={H3}
            />
          ),
          className: s.dialog,
          bodyClassName: s.dialogBody,
          titleClassName: s.dialogTitle,
        },
      ).then(() => {
        resolve(false);
      });
    });

  return { open };
};
